import { SlideData } from '@/models/mobileApp';
import i18n from '@/plugins/i18n';

export const BreadcrumbId = 'app-breadcrumb';

export const LoginTypesIds = {
  individuals: 1,
  business: 2,
  governmental: 3,
  lawyers: 4,
};

export const MobileAppsSlides: SlideData[] = [
  {
    title: i18n.t('sessionsAttendence') as string,
    image: '/img/appSlide1.svg',
  },
  {
    title: i18n.t('ePayment') as string,
    image: '/img/appSlide2.svg',
  },
  {
    title: i18n.t('executionRequestActions') as string,
    image: '/img/appSlide3.svg',
  },
  {
    title: i18n.t('virtualCourtExecutionRequest') as string,
    image: '/img/appSlide4.svg',
  },
];

export enum ContactUsCategoryOptionsEnum {
  Question = 'question',
  Suggestion = 'suggestion',
  Help = 'help',
}

export const CONTACT_US_MESSAGE_CATEGORY_OPTIONS = [
  {
    value: ContactUsCategoryOptionsEnum.Question,
    label: i18n.t('contactWithUs.question') as string,
  },
  {
    value: ContactUsCategoryOptionsEnum.Suggestion,
    label: i18n.t('contactWithUs.suggestion') as string,
  },
  {
    value: ContactUsCategoryOptionsEnum.Help,
    label: i18n.t('contactWithUs.help') as string,
  },
];
